export default __webpack_public_path__ + "static/media/holder.0b6911e5.png";